import { trackEvent } from "../../../trackEvent";
import getActionButtonText from "../../../helpers/getActionButtonText";

/**
 * Push any header links to datalayer when they are in the .header tag
 * Basic DOM markup assumed.
 * 
 * <div class="header">
 *  <div data-gtm-subsection="social">
 *   <button data-gtm-click>Facebook</a>
 *  </div>
 * </div>
 */

const test = ({ target }) => target.closest("#ps-widget");

const push = ({ target }) => {
  const targetRetailer = target.classList.contains("ps-online-seller-details-wrapper") ? target : target.closest("[data-retailer]");
  
  if (targetRetailer) {
    const psData = targetRetailer.dataset;
    const linkText = targetRetailer.querySelector(".ps-online-buy-button span")?.textContent;
    
    const wtbButton = document.querySelector(".whereToBuyBtn a");   
    const link = wtbButton? wtbButton.getAttribute("href") : window.location.pathname;

    trackEvent({
      event: "click_retailer",
      event_type: "click",
      element_url: linkText,
      element_text: linkText,
      item_name: psData.name,
      retailer_name: psData.retailer
    });  
  }
}

export default {
  name: "ps-widget",
  test,
  push
};